import { render, staticRenderFns } from "./WidgetWallet.vue?vue&type=template&id=34eeca60&"
import script from "./WidgetWallet.vue?vue&type=script&lang=ts&"
export * from "./WidgetWallet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports